import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../../../components/SEO';
import Layout from '../../../layouts/index';
import HtmlParser from 'html-react-parser';
import { DemoFormLong } from '../../../components/DemoFormLong.jsx';
import { DemoFormLongPDFNoBackground} from '../../../components/DemoFormLongPDFNoBackground.jsx';
import JoinHappyCustomers from '../../../components/JoinHappyCustomers';
import { Link } from 'react-scroll';

const Home = (props) => {    
    const json = props.data.allTestimonialsJson.edges;

    function shuffle(array) {
        array.sort(() => Math.random() - 0.5);
    }

    shuffle(json);
    const location = props.location;   


    return (
        <Layout bodyClass="page-covid-data" ontouchstart>
            <SEO title="Return to Work Guide | ChartHop | The Org Management Platform" />
            <Helmet>
                <meta
                    name="description"
                    content="The return to work requires thoughtful data collection and analysis. This return to work guide includes the types of questions companies are asking."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Return to Work Guide | ChartHop | The Org Management Platform" />
                <meta property="og:description" content="The return to work requires thoughtful data collection and analysis. This return to work guide includes the types of questions companies are asking." />
                <meta property="og:image" content={`https://www.charthop.com/landings/charthop-return-to-work.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Return to Work Guide | ChartHop | The Org Management Platform" />
                <meta name="twitter:description" content="The return to work requires thoughtful data collection and analysis. This return to work guide includes the types of questions companies are asking." />
                <meta name="twitter:image" content={`https://www.charthop.com/landings/charthop-return-to-work.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>
            
            {/* HEADER */}            
            <section className="hero-dei-reporting">
                <div className="row pb-1 sectionSpacing contentBlock section-big">
                    <div className="headerContent col-md-6 col-sm-12">
                        <h1 className="h1">Make the return to office safe and comfortable for everyone.</h1>
                    </div>
                </div>
                <div className="row pt-1 sectionSpacing contentBlock justify-content-md-start justify-content-center section-big">
                    <DemoFormLongPDFNoBackground pdfUrl={'/resources/return-to-office-guide-charthop.pdf'} source={"resources-return-to-work-PDF-contentdownload-header"}/>
                </div>
            </section>

            {/* SET REMOTE */}
            <section className="set-remote sectionSpacing backgroundGradientContainer">
                <div className="contentBlock">
                <h2 className="text-center mt-0 sectionSpacing-Margin">The return to office requires thoughtful data collection and analysis. </h2>
                <h4 className="text-center my-2">This Return to Office Guide includes:</h4>
                <div className="contentBlock">
                    <div className="pgc1-2 pgc1">
                        <div className="pgc2-2 pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Dozens of questions companies are asking</p>
                            </div>
                        </div>
                        <div className="pgc2-2 pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>How to align the process with your values</p>
                            </div>
                        </div>
                        <div className="pgc2-2 pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Tips on centralizing and analyzing data</p>
                            </div>
                        </div>
                    </div>                    
                    <p className="text-center mt-2 p-big sectionSpacing-Margin">Companies are proactively planning for the future of their workplace. A data-informed plan can make all the difference.</p>
                </div>
                </div>
            </section>


 

             {/* ONE PLACE */}
             <section className="one-place sectionSpacing">
                <div className="container pt-2">
                    <div className="col-md-12 text-center">							
                        <h2 className="mb-2 mb-md-4">Empower effective decision-making with ChartHop</h2>
                    </div>

                    <div className="container text-center">  

                        {/* Aggregate */}
                        <div name="Aggregate" id="Aggregate" className="row align-items-center pb-3 pb-md-4 pb-lg-5 pt-3 pt-mt-4 pt-lg-5 text-center text-md-left">
                            <div className="col-md-7 col-lg-6">
                                <div className="mr-md-2 mr-lg-4">
                                    <h3>Centralize all relevant data</h3>
                                    <p>Seamlessly integrate your existing HR tech to see survey data within your org structure and alongside other employee data.</p>
                                </div>
                            </div>
                            <div className="col-md-5 col-lg-6" >
                                <img className="imageBoxShaddow fullSegmentImage mx-auto" src={'/covid-data/aggregate-relevant-data.gif'} alt="Aggregate with relevant data" />
                            </div>
                        </div>

                        {/* Analyze */}
                        <div name="Analyze" id="Analyze" className="row align-items-center pb-3 pb-md-4 pb-lg-5 pt-3 pt-mt-4 pt-lg-5 text-center text-md-right">
                            <div className="col-md-7 col-lg-6 order-md-2">
                                <div className="ml-md-2 ml-lg-4">                                    
                                    <h3>Ensure stakeholder alignment</h3>
                                    <p>Create and share robust reports that update as your data updates, without spreadsheet gymnastics. </p>                                    
                                </div>
                            </div>
                            <div className="col-md-5 col-lg-6 order-md-1" >
                                <img className="imageBoxShaddow fullSegmentImage mx-auto" src={'/covid-data/return-to-work-reports.gif'} alt="Analyze trends and results" />
                            </div>
                        </div>

                         {/* Analyze trends and results */}
                         <div name="Act early" id="Act early" className="row align-items-center pb-3 pb-md-4 pb-lg-5 pt-3 pt-mt-4 pt-lg-5 text-center text-md-left">
                            <div className="col-md-7 col-lg-6">
                                <div className="mr-md-2 mr-lg-4">
                                    <h3>Analyze trends and results</h3>
                                    <p>Track as survey responses change over time. Understand how responses differ across departments, offices, gender, race/ethnicy, tenure, performance and more.</p>
                                </div>
                            </div>
                            <div className="col-md-5 col-lg-6" >
                                <img className="imageBoxShaddow fullSegmentImage mx-auto" src={'/covid-data/analyze-trends-results.gif'} alt="Act early and often" />
                                {/* /covid-data/act-early-often.png */}                                
                            </div>
                        </div>
                        <Link to="request-demo" smooth={true} offset={-70} duration={500} class="button primary">REQUEST A DEMO</Link>                        
                    </div>                   
                </div>                
            </section>   

            {/* OUTGROWN */}
            <section className="outgrown trio-icon-section sectionSpacing backgroundGradientContainer-Reverse">
                <div className="container pt-2">
                    <div className="col-md-12 text-center">							
                        <h2 className="mb-2 mb-md-4">You’ve outgrown the makeshift spreadsheets.</h2>	
                        <h3>With ChartHop you can:</h3>
                    </div>		
                    <div className="row mt-4">
                        <div className="col-md-4 col-lg-4 col-xs-6 text-center">
                            <img src='/covid-data/icon-one-place.svg' alt="One Place" className="" />
                            <h3>House all data in one place</h3>
                            <p>No need to create yet another spreadsheet or send employees to multiple tools.</p> 
                        </div>
                        <div className="col-md-4 col-lg-4 col-xs-6 text-center">
                            <img src='/covid-data/icon-collect.svg' alt="One Place" className="" />
                            <h3>Collect data continuously</h3>
                            <p>Situations evolve quickly. Collect data monthly, weekly or even daily.</p> 
                        </div>
                        <div className="col-md-4 col-lg-4 col-xs-6 text-center">
                            <img src='/covid-data/icon-participation.svg' alt="One Place" className="" />
                            <h3>Get max participation</h3>
                            <p>Send slack and email notifications to increase survey completion.</p> 
                        </div>
                        <div className="col-md-4 col-lg-4 col-xs-6 text-center">
                            <img src='/covid-data/icon-protect.svg' alt="One Place" className="" />
                            <h3>Protect employee privacy</h3>
                            <p>Control access to survey results and ensure private data remains private.</p> 
                        </div>
                        <div className="col-md-4 col-lg-4 col-xs-6 text-center">
                            <img src='/covid-data/icon-empower.svg' alt="One Place" className="" />
                            <h3>Empower managers</h3>
                            <p>Safely provide data and context they need to best support employees. </p> 
                        </div>
                        <div className="col-md-4 col-lg-4 col-xs-6 text-center">
                            <img src='/covid-data/icon-plan.svg' alt="One Place" className="" />
                            <h3>Build plans off the data</h3>
                            <p>Create cohort or headcount  plans, keep track of changes and collaborate with others. </p> 
                        </div>
                    </div>
                </div>
            </section>

            {/* COHORTS */}
            <section className="cohorts sectionSpacing">
                <div className="container pt-2">
                    <div className="col-md-12 text-center">							
                        <h2 className="mb-2">Design balanced and equitable cohorts</h2>
                    </div>

                    <div className="container">  

                        {/* Cohorts */}
                        <div name="cohorts" id="cohorts" className="row align-items-center pt-3 text-center text-md-left">
                            <div className="col-md-7 col-lg-6">
                                <div className="mr-md-2 mr-lg-4">
                                    <h3>Plan out potential cohorts in Scenarios using all of the data collected. </h3>
                                    <ul>
                                        <li>Collaborate on cohort definition</li>
                                        <li>Visualize the org chart by cohort</li>
                                        <li>Ensure cohorts are balanced</li>
                                        <li>Iterate on plans as needs evolve</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-5 col-lg-6" >
                                <img className="imageBoxShaddow fullSegmentImage mx-auto" src={'/covid-data/potential-cohorts.png'} alt="Design balanced and equitable cohorts" />
                            </div>
                        </div>
                        {/* Balance */}
                        <div className="mt-5 text-center">
                            <h3>Balance out cohorts by:</h3>
                            <div className="pgc1">
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                        <p>Gender</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                        <p>Ethnicity</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                        <p>Level</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                        <p>Department</p>
                                    </div>
                                </div>                                
                            </div>
                            <Link to="request-demo" smooth={true} offset={-70} duration={500} class="button primary">REQUEST A DEMO</Link>
                        </div>                        

                    </div>
                </div>
            </section>


           

            {/* NAVIGATE */}
            <section className="navigate trio-icon-section sectionSpacing backgroundGradientContainer-Reverse">
                <div className="container pt-2">
                    <div className="col-md-12 text-center">							
                        <h2 className="mb-2 mb-md-4">Navigate through this transition and build the foundation for a stronger team with ChartHop.</h2>                        
                    </div>		
                    <div className="row mt-4">
                        <div className="col-md-4 col-lg-4 col-xs-6 text-center">
                            <img src='/covid-data/icon-evolution.svg' alt="One Place" className="" />
                            <h3>Visualize your team & its evolution</h3>
                            <p>Never make an org chart in ppt again. </p>
                            <p>Give every team member context about who is who and how they fit into the greater organization. Travel through time to see how the org has changed.</p> 
                        </div>
                        <div className="col-md-4 col-lg-4 col-xs-6 text-center">
                            <img src='/covid-data/icon-workflows.svg' alt="One Place" className="" />
                            <h3>Power planning workflows</h3>
                            <p>Stop emailing spreadsheets back and forth.</p>
                            <p>Collaborate across the team on future hiring plans, alternative team structures, compensation changes, promotions plans & more. </p> 
                        </div>
                        <div className="col-md-4 col-lg-4 col-xs-6 text-center">
                            <img src='/covid-data/icon-analytics.svg' alt="One Place" className="" />
                            <h3>Effortlessly track people analytics</h3>
                            <p>Don’t create and update charts manually.</p> 
                            <p>Build robust reports that are automatically updated as data changes from your disparate systems. Easily share reports for management meetings, board meetings, all hands & more.</p> 
                        </div>                        
                    </div>
                </div>
            </section>

            {/* TRUSTED */}
            <section className="customer testimonial-container pt-8 pb-5">
                <JoinHappyCustomers title={HtmlParser('Trusted <span class="blue-text">by</span>')}></JoinHappyCustomers>
            </section>

            {/* CONTACT FORM */}
            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={"resources-return-to-work-demo-bottom"} headertext={HtmlParser("<h3>The return to work requires thoughtful data collection and analysis.</h3><br></br><h2>We’re here to help.</h2>")}/>
            </section>

        </Layout>
    );
};


export default Home;


export const query = graphql`
  query {
    allTestimonialsJson {
      edges {
        node {
          id
          name
          title
          quote
          image
        }
      }
    }
  }
`;